var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('el-row',{attrs:{"gutter":20}},[_c('el-col',{attrs:{"span":8}},[_c('letf-page')],1),_c('el-col',{attrs:{"span":8}},[_c('center-page')],1),_c('el-col',{attrs:{"span":8}},[_c('right-page')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }